var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-header-title"},[_c('span',{on:{"click":function($event){_vm.rootDir = null}}},[_vm._v("Topics")])])]),_c('div',{staticClass:"card-content"},[_c('software-topics',{attrs:{"topics":_vm.topics},on:{"select":_vm.selectTopic}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }